/**
 * A target, and how far along it is.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readString } from '@/domain/json'
import { type TargetSection } from '@/domain/section'
import TargetBlock from '@/sections/target/TargetBlock.vue'
import TargetInspector from '@/sections/target/TargetInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const targetSection: SectionDefinition<'target', TargetSection> = {
  kind: 'target',
  band: 'sustainability',

  icon: ['M8 3v10', 'M8 3l4.5 2-4.5 2', 'M3.5 13.5h9'],

  create: (id, title) => ({
    id,
    kind: 'target',
    title,
    label: title,
    unit: '',
    baseYear: '',
    baseValue: '',
    targetYear: '',
    targetValue: '',
    currentValue: '',
    note: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'target',
    title,
    label: readString(stored, 'label'),
    unit: readString(stored, 'unit'),
    baseYear: readString(stored, 'baseYear'),
    baseValue: readString(stored, 'baseValue'),
    targetYear: readString(stored, 'targetYear'),
    targetValue: readString(stored, 'targetValue'),
    currentValue: readString(stored, 'currentValue'),
    note: readString(stored, 'note'),
  }),

  block: TargetBlock,
  inspector: TargetInspector,
}
